var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
import { ContentBaseService } from '../base/contentbase.service';
import { ColumnService } from '../../items/columns/column/column.service';
var QuestionnaireService = /** @class */ (function (_super) {
    __extends(QuestionnaireService, _super);
    function QuestionnaireService(logger, api, colservice) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.colservice = colservice;
        _this._subject = new Subject();
        return _this;
    }
    Object.defineProperty(QuestionnaireService.prototype, "observable", {
        get: function () {
            return this._subject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    QuestionnaireService.prototype.sortItems = function (items) {
        items.sort(function (a, b) {
            if (a.disp_order < b.disp_order) {
                return -1;
            }
            if (a.disp_order > b.disp_order) {
                return 1;
            }
            return 0;
        });
    };
    QuestionnaireService.prototype.checkItem = function (rec) {
        var items = rec['items'] || [];
        var its = [];
        var check = true;
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (item.$type === "delete" /* Delete */) {
                continue;
            }
            if (!this.colservice.checkVal(item.form_type)) {
                check = false;
            }
            else if (item.form_type === "image" /* image */) {
                if (!this.colservice.checkVal(item.image_path)) {
                    check = false;
                }
            }
            else if (item.form_type !== "paging" /* paging */) {
                if (!this.colservice.checkVal(item.name)) {
                    check = false;
                }
                if (item.form_type !== "title" /* title */ && !this.colservice.checkVal(item.is_required)) {
                    check = false;
                }
                if (item.form_type === "radio" /* radio */ || item.form_type === "checkbox" /* checkbox */ || item.form_type === "select" /* select */) {
                    if (item.questionnaire_form_element_m.length === 0) {
                        check = false;
                    }
                    else {
                        for (var _a = 0, _b = item.questionnaire_form_element_m; _a < _b.length; _a++) {
                            var element = _b[_a];
                            if (!element.is_other_field && !this.colservice.checkVal(element.label)) {
                                check = false;
                            }
                        }
                    }
                }
            }
            its.push(item);
        }
        if (its.length === 0) {
            check = false;
        }
        if (!check) {
            this._subject.next(true);
        }
        return check;
    };
    QuestionnaireService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    QuestionnaireService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: ColumnService }
    ]; };
    return QuestionnaireService;
}(ContentBaseService));
export { QuestionnaireService };
var Form = /** @class */ (function () {
    function Form() {
        this.$type = "post" /* Post */;
        this.is_required = false;
        this.questionnaire_form_element_m = [];
    }
    return Form;
}());
export { Form };
var FormElement = /** @class */ (function () {
    function FormElement() {
        this.is_other_field = false;
    }
    return FormElement;
}());
export { FormElement };
var FormU = /** @class */ (function () {
    function FormU() {
    }
    return FormU;
}());
export { FormU };
//# sourceMappingURL=questionnaire.service.js.map